import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, LOGO_URL } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("wbz_admin_token", data.access_token);
      localStorage.setItem("wbz_admin_email", data.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="bg-stone-950 text-stone-50 min-h-screen flex items-center justify-center px-6 py-20"
    >
      <div className="max-w-md w-full border border-stone-800 bg-stone-900/40 p-10">
        <div className="text-center mb-10">
          <img
            src={LOGO_URL}
            alt="Wood by ZQ"
            className="h-16 w-16 mx-auto logo-invert object-contain"
          />
          <p className="text-overline text-stone-500 mt-4">Owner login</p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-overline text-stone-500 block mb-2">Email</label>
            <input
              type="email"
              required
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-stone-950 border border-stone-800 focus:border-amber-600 outline-none p-4 text-stone-100"
            />
          </div>
          <div>
            <label className="text-overline text-stone-500 block mb-2">Password</label>
            <input
              type="password"
              required
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-stone-950 border border-stone-800 focus:border-amber-600 outline-none p-4 text-stone-100"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-amber-700 hover:bg-amber-600 disabled:bg-stone-800 text-stone-50 px-6 py-4 text-overline flex items-center justify-center gap-3 transition-colors"
          >
            <Lock size={14} /> {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-8 text-center">
          <Link to="/" className="text-stone-500 hover:text-amber-500 text-xs uppercase tracking-widest">
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
